<template>
    <div class="case">
        <div class="imageBox">
            <img class="image" :src="'../../../static/img/'+type" alt="">
        </div>
        <div class="infos">
            <h2 class="title">{{info.title}}</h2>
            <!-- <p class="keyWords">{{info.keyWord}}</p> -->
            <p class="topic">{{info.classType}} <span class="creatTime">{{info.createTime | formatTime}}</span> </p>
            <!-- <p class="creatTime">{{info.createTime | formatTime}}</p> -->
            <p class="synopsis twoe">{{info.synopsis}}</p>
        </div>
    </div>    
</template>

<script>
export default {
    props: {
        info: {}
    },
    computed: {
        type() {
            let data = "链接"
            if(this.info.type) {
                let type = this.info.type.toLowerCase();
                for(let i in Base.FILE_TYPE){
                    if(Base.FILE_TYPE[i].includes(type)) {
                        data = i
                    }
                }
                return data
            }else {
                return 'link.png'
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .case{
        padding: 20px 10px;
        border-bottom: 1px solid #dddddd;
        cursor: pointer;
        &:hover .title{
            color: #2b85e4;
        }
        &::after {
            content: "";
            display: block;
            height: 0;
            clear: both;
            visibility: hidden;
        }
        .imageBox{
            float: left;
            width: 80px;
            height: 80px;
            margin-right: 30px;
            .image{
                width: 100%;
                height: 100%;
            }
        }
        .infos{
            float: left;
            width: 775px;
            .title{
                font-size: 20px;
            }
            .keyWords{
                color: #9ea7b4;
                font-size: 18px;
            }
            .topic{
                font-size: 16px;
                // margin-top: 10px;
            }
            .creatTime{
                margin-top: 10px;
                font-size: 12px;
            }
            .synopsis{
                margin-top: 10px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/File/Case.vue